import { createTheme } from '@mui/material/styles';

export const saloonTokens = {
  navy950: '#0a1322',
  navy900: '#0e1a2d',
  navy800: '#122339',
  navy700: '#18304d',
  orange500: '#e8821f',
  orange400: '#f59838',
  orange300: '#ffb45c',
  orange200: '#ffd089',
  rust700: '#7a3a10',
  rust800: '#4a230a',
  bone: '#f1e3c7',
  bone2: '#d9c79e',
  ink: '#1a0e06',
  ink2: '#2b170a',
  blueCard1: '#1d4f8a',
  blueCard2: '#143562'
};

export const saloonFonts = {
  body: "'Inter', system-ui, sans-serif",
  decorative: "'Rye', serif",
  numeric: "'Oswald', sans-serif",
  typewriter: "'Special Elite', monospace"
};

const saloonTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: saloonTokens.orange500,
      light: saloonTokens.orange300,
      dark: saloonTokens.rust700,
      contrastText: saloonTokens.ink
    },
    secondary: {
      main: saloonTokens.bone,
      light: saloonTokens.bone2,
      dark: saloonTokens.rust800,
      contrastText: saloonTokens.ink
    },
    background: {
      default: saloonTokens.navy950,
      paper: saloonTokens.navy900
    },
    text: {
      primary: saloonTokens.bone,
      secondary: saloonTokens.bone2
    },
    divider: 'rgba(232, 130, 31, 0.25)'
  },
  typography: {
    fontFamily: saloonFonts.body,
    h1: { fontFamily: saloonFonts.decorative },
    h2: { fontFamily: saloonFonts.decorative },
    h3: { fontFamily: saloonFonts.decorative },
    h4: { fontFamily: saloonFonts.numeric, fontWeight: 700 },
    h5: { fontFamily: saloonFonts.numeric, fontWeight: 600 },
    h6: { fontFamily: saloonFonts.numeric, fontWeight: 600 },
    button: {
      fontFamily: saloonFonts.body,
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.08em'
    },
    overline: { fontFamily: saloonFonts.typewriter, letterSpacing: '0.12em' }
  },
  shape: {
    borderRadius: 8
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8
        },
        containedPrimary: {
          background: `linear-gradient(180deg, ${saloonTokens.orange300}, ${saloonTokens.orange500} 60%, #b85f12)`,
          color: saloonTokens.ink,
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25), 0 2px 6px rgba(0,0,0,0.35)',
          '&:hover': {
            background: `linear-gradient(180deg, ${saloonTokens.orange200}, ${saloonTokens.orange400} 60%, ${saloonTokens.rust700})`
          }
        }
      }
    }
  }
});

export default saloonTheme;
